<script>
import devConfig from '../../../config/.development'
import productionConfig from '../../../config/.production'

let variable = {
  methods: {
    getAccessKey () {
      if (process.env.NODE_ENV === 'development') {
        return devConfig.ACCESS_KEY
      } else {
        return productionConfig.ACCESS_KEY
      }
    },
    defaultLocation () {
      return {
        lat: 35.7092776,
        lng: 139.7323649
      }
    }
  }
}

export default variable
</script>



// WEBPACK FOOTER //
// src/utils/vue/Variable.vue